<template>
  <div>
    <div class="row">
      <div class="item wid_10 bold">{{date | isToday}}</div>
      <span class="line"></span>
      <div class="item wid_10">{{time}}</div>
      <span class="line"></span>
      <div class="item wid_20" :title="content.remark">{{content.remark || '--'}}</div>
      <span class="line"></span>
      <div class="item wid_20" v-if="content.accountId === code.cashCode || content.accountId === code.contractCashCode">现金余额：￥{{content.balance | fmtMoney(1e3)}}</div>
      <div class="item wid_20" v-else>--</div>
      <span class="line"></span>
      <div class="item wid_20" v-if="content.accountId === code.grantCode || content.accountId === code.contractGrantCode">赠款余额：￥{{content.balance | fmtMoney(1e3)}}</div>
      <div class="item wid_20" v-else>--</div>
      <span class="line"></span>
      <div :class="['item', 'wid_20', content.historyOptType === 1 ? 'pink' : 'blue']">{{content.historyOptType === 1 ? '+' : '-'}}{{ content.money | fmtMoney(1e3)}}</div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'ColTable',
    props: {
      content: {
        type: Object,
        required: true,
      },
      code: {
        type: Object,
        required: true,
      }
    },
    filters: {
      // 判断是否为今天
      isToday (v) {
        let nowDate = moment(new Date()).format('YYYY-MM-DD')
        if (v === nowDate) {
          return '今天'
        }
        if (moment(v).add(1, 'days').format('YYYY-MM-DD') === nowDate) {
          return '昨天'
        }
        return moment(v).format('MM-DD')
      },
      fmtMoney (v, r) {
        if (v !== null) {
          if (v === 0) return '0.00'
          if (v !== undefined && !isNaN(v)) {
            let str = Number((v / r).toFixed(2)).toLocaleString()
            const dot = str.indexOf('.')
            if (dot >= 0) {
              let dec = str.slice(dot + 1, str.length)
              if (dec.length < 2) dec += '0'
              str = str.slice(0, dot + 1) + dec
            } else {
              str += '.00'
            }
            return str
          }
          return ''
        }
      }
    },
    computed: {
      date () {
        return this.content.dateTime.split(' ')[0]
      },
      time () {
        return this.content.dateTime.split(' ')[1]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .row {
    width: 100%;
    height:50px;
    background: #ffffff;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(59,63,69,1);
    .bold {
      font-weight: 500;
    }
    .item {
      display: inline-block;
      height:50px;
      line-height:50px;
      text-align: center;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      padding: 0 10px;
    }
    .wid_10 {
      width: 9%;
    }
    .wid_20 {
      width: 20%;
    }
    .line {
      width: 1px;
      display: inline-block;
      background: #EAEBF0;
      height: 12px;
      transform: translateY(-19px);
    }
    .pink {
      color: #FF3973;
    }
    .blue {
      color: #6296FF;
    }
  }
</style>

